export default "__VITE_ASSET__BAAhfHmG__"